import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Link } from '@material-ui/core';
import Icons from '../Icons';
import analytics from '../../../utils/analytics';
import I18n from '../../../config/locales';
import { getToken, decodeToken, getCountryBasedLink } from '../../../utils/helper';

const useStyles = makeStyles(theme => ({
  support: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  supportText: {
    color: theme.palette.tertiary.main,
    fontSize: 13,
    paddingTop: theme.spacing(0.5),
    textAlign: 'center',
    cursor: 'pointer'
  },
  supportTextWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'relative'
  },
  comingSoon: {
    '& *': {
      color: '#AAA9A9 !important'
    },
    '& svg': {
      fill: '#AAA9A9 !important'
    }
  },
  comingSoonLabel: {
    background: '#A5A5A5 0% 0% no-repeat padding-box',
    letterSpacing: 0,
    lineHeight: 0,
    color: `${theme.palette.secondary.main} !important`,
    textTransform: 'uppercase',
    height: theme.spacing(1.5),
    fontSize: 8,
    display: 'flex',
    fontWeight: 'bold',
    alignItems: 'center',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(0, 0.5),
    position: 'absolute',
    right: theme.spacing(-3),
    top: theme.spacing(-0.5)
  },
  disabledSupportText: {
    pointerEvents: 'none'
  },
  new: {
    '& *': {
      color: '#AAA9A9 !important'
    },
    '& svg': {
      fill: '#AAA9A9 !important'
    }
  },
  newLabel: {
    background: '#FF7141 0% 0% no-repeat padding-box',
    letterSpacing: '0 !important',
    lineHeight: '0 !important',
    color: theme.palette.secondary.main,
    textTransform: 'uppercase',
    height: theme.spacing(1.5),
    fontSize: '9px !important',
    display: 'flex',
    fontWeight: 'bold',
    alignItems: 'center',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(0, 0.5),
    position: 'absolute',
    top: theme.spacing(-0.5),
    left: theme.spacing(9)
  }
}));

const SupportElement = props => {
  const { data } = props;
  const classes = useStyles();
  const gaAnalytics = new analytics();
  const SupportIcon = Icons[data.type];

  const events = {
    event: 'triggerQuickAccess'
  };
  const trackEvent = (data, event) => {
    if (data.type === 'commercial') {
      gaAnalytics.triggerEvent({ event: 'triggerCommercialEntry' });
    } else {
      const dataLayer = {
        quickAccessValue: data.name
      };
      gaAnalytics.triggerEvent(events, dataLayer);
    }
    if (data.type == "service" && window.build_environment === 'qa2' || window.build_environment === 'production') {
      event.preventDefault()
      serviceManagerLogin()
      return false;
    }
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  function redirectToServiceManagerLink(url) {
    window.open(url, '_blank');
  }

  const serviceManagerLogin = async () => {
    const token = getToken();
    const { session_id: sessionId, email_id: username } = decodeToken(token);
    let smBaseUrl = getCountryBasedLink('serviceManagerBaseUrl')

    // var smSiteUrl = `${smBaseUrl}/${locale}/systems/${site_id}`;
    // var smLoginUrl = `${smBaseUrl}/${locale}/?login=y`;

    var smLoginUrlWithoutLocale = `${smBaseUrl}/?login=y`;
    var smDashboardUrlWithoutLocale = `${smBaseUrl}/`;

    // var myHeaders = new Headers();
    // myHeaders.append("Cookie", `sm_locale=${locale}`);

    var requestOptions = {
      method: 'GET',
      // headers: myHeaders,
      redirect: 'follow',
      credentials: 'include'
    };

    await fetch(`${smBaseUrl}/api/internal/validate_session`, requestOptions)
      .then(response => {
        if (response.status === 200) {
          // Valid session available, redirect to the service manager link, auto login
          redirectToServiceManagerLink(smDashboardUrlWithoutLocale);
        }
        else if (response.status === 401 || response.status === 403) {
          // No valid session, authenticate and redirect
          var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
          var urlencoded = new URLSearchParams();
          urlencoded.append("username", username);
          urlencoded.append("password", sessionId);
          var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow',
            credentials: 'include'
          };
          fetch(`${smBaseUrl}/users/auth/enlighten`, requestOptions)
            .then(response => {
              if (response.status === 200) {
                // Authenticated, redirect to the service manager link, auto log in
                redirectToServiceManagerLink(smDashboardUrlWithoutLocale);
              }
              else {
                // redirect to the service manager link, user should manually log in
                redirectToServiceManagerLink(smLoginUrlWithoutLocale);
              }
            })
            .catch(error => {
              redirectToServiceManagerLink(smDashboardUrlWithoutLocale);
            })
        }
        else {
          // API call failed, redirect for manual login
          redirectToServiceManagerLink(smLoginUrlWithoutLocale);
        }
      })
      .catch(error => {
        redirectToServiceManagerLink(smLoginUrlWithoutLocale);
      })
  }

  return (
    <Box className={classes.support}>
      <Box className={clsx(classes.supportTextWrapper, data.isComingSoon && classes.comingSoon)}>
        <SupportIcon />
        {data.type == "service" ? <Link
          target={data.isInternalLink ? '_self' : '_blank'}
          href={(window.build_environment !== 'qa2' && window.build_environment !== 'production') ? data.url : undefined}
          className={clsx(classes.supportText, data.isComingSoon && classes.disabledSupportText)}
          onClick={(event) => trackEvent(data, event)}
          onContextMenu={handleContextMenu}
        >
          {data.name}
        </Link> :
          <Link
            target={data.isInternalLink ? '_self' : '_blank'}
            href={data.url}
            className={clsx(classes.supportText, data.isComingSoon && classes.disabledSupportText)}
            onClick={() => trackEvent(data)}
          >
            {data.name}
          </Link>
        }
        {data.isComingSoon && (
          <Typography className={classes.comingSoonLabel}>{I18n.t('header.comingSoon')}</Typography>
        )}
        {data.isnew && (
          <Typography className={classes.newLabel}>{I18n.t('header.new')}</Typography>
        )}
      </Box>
    </Box>
  );
};

export default SupportElement;
